import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  card: {
    overflow: 'hidden',
    marginTop: 32,
    marginBottom: 32,
  },
  adminCard: {
    overflow: 'hidden',
  },
  topContainer: {
    padding: 32,
  },
};

export default styles;
